import { API_BASE_URL } from '@/utils/request'
import { getMediaPlayUrl } from '@/utils/http'
import { resolveImageUrl } from '@/utils/content'

function apiBase() {
  return (API_BASE_URL || '/api').replace(/\/$/, '')
}

/** Guess MIME from URL path (ignore query/hash). */
export function guessVideoMime(url) {
  const path = String(url || '').split('?')[0].split('#')[0].toLowerCase()
  if (path.endsWith('.webm')) return 'video/webm'
  if (path.endsWith('.ogg') || path.endsWith('.ogv')) return 'video/ogg'
  if (path.endsWith('.m3u8')) return 'application/vnd.apple.mpegurl'
  return 'video/mp4'
}

export function buildMediaStreamUrl(rawUrl) {
  if (!rawUrl) return ''
  return apiBase() + '/common/mediaStream?url=' + encodeURIComponent(rawUrl)
}

/**
 * Resolve a cross-browser playable URL list for an OSS/CMS video.
 * Order: signed inline OSS ?? stream proxy ?? raw URL
 */
export async function resolveVideoPlaySources(rawInput) {
  const raw = resolveImageUrl(rawInput || '') || String(rawInput || '').trim()
  if (!raw) return []

  const sources = []
  const seen = new Set()
  const push = (url, type) => {
    if (!url || seen.has(url)) return
    seen.add(url)
    sources.push({ src: url, type: type || guessVideoMime(raw) })
  }

  try {
    const res = await getMediaPlayUrl(raw)
    const playUrl = (
      (res && (res.playUrl || res.url)) ||
      (res && res.data && (res.data.playUrl || res.data.url || (typeof res.data === 'string' ? res.data : ''))) ||
      ''
    )
    if (playUrl) push(String(playUrl), guessVideoMime(raw))
  } catch (e) { /* ignore */ }

  push(buildMediaStreamUrl(raw), guessVideoMime(raw))
  push(raw, guessVideoMime(raw))
  return sources
}
